<script>
	import Cdh from "./cdh/Cdh.svelte";
	import Cmdw from "./cmdw/Cmdw.svelte";
	import Home from "./home/Home.svelte";
	import Navigation from "./Navigation.svelte";
	import Sdmt from "./sdmt/Sdmt.svelte";

	let currentRoute = "home";
</script>

<main>
	<Navigation bind:currentRoute="{currentRoute}">
		<section class="section">
			<div class="container">
				{#if currentRoute === 'home'}
					<Home></Home>
				{:else if currentRoute === 'cmdw'}
					<Cmdw></Cmdw>
				{:else if currentRoute === 'cdh'}
					<Cdh></Cdh>
				{:else if currentRoute === 'sdmt'}
					<Sdmt></Sdmt>
				{/if}
			</div>
		</section>
	</Navigation>
</main>

<style>
  .section {
    padding: 4rem 1rem;
  }

  @media (min-width: 600px) {
    .section {
		  padding: 4rem 3rem;
    }
  }
</style>
